import { Box, Chip, Container, Dialog, DialogActions, DialogContent, Grid2, Stack, Tab, Tabs } from "@mui/material";
import DeliveryDocuments from "./DeliveryDocuments";
import DeliveryRegularization from "./DeliveryRegularization";
import React from "react";
import { useEffect, useState } from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CalendarMonthTwoToneIcon from '@mui/icons-material/CalendarMonthTwoTone';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import StoreTwoToneIcon from '@mui/icons-material/StoreTwoTone';
import PersonOutlineTwoToneIcon from '@mui/icons-material/PersonOutlineTwoTone';
import EmojiTransportationTwoToneIcon from '@mui/icons-material/EmojiTransportationTwoTone';
import BallotIcon from '@mui/icons-material/Ballot';
import AddTaskIcon from '@mui/icons-material/AddTask';
import Div from "@jumbo/shared/Div";
import deliveryServices from 'app/services/delivery-services';
import Tooltip from '@mui/material/Tooltip';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from 'notistack';

const bull = (
  <Box
    component="span"
    color="text.secondary"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

const defaultIcons = {
  'Fecha de entrega': <CalendarMonthTwoToneIcon fontSize="small" color={"primary"} mr={3}/>,
  'Patente': <LocalShippingTwoToneIcon fontSize="small" color={"primary"} />,
  'Cliente': <StoreTwoToneIcon fontSize="small" color={"primary"} />,
  'Conductor': <PersonOutlineTwoToneIcon fontSize="small" color={"primary"} />,
  'Transportista': <EmojiTransportationTwoToneIcon fontSize="small" color={"primary"} />,
  'Pedido': <BallotIcon fontSize="small" color={"primary"} />,
  'Instructivo': <AddTaskIcon fontSize="small" color={"primary"} />,
  'default': <SignalCellularAltIcon fontSize="small" color={"primary"} />
}

// Esta debería llegar del deliveryService
const cardData = {
  title: 'Entrega',
  partial: true,
  subtitle: '23453',
  sortedAttributes: [
    {
      title: 'Fecha de entrega',
      value: '12/12/2021'
    },
    {
      title: 'Patente',
      value: 'LKGY68'
    },
    {
      title: 'Cliente',
      value: 'Aceites Barraza'
    },
    {
      title: 'Conductor',
      value: 'Guillermo Barazarte Pérez'
    },
    {
      title: 'Transportista',
      value: 'Transportes Bretti'
    },
    {
      title: 'Pedido',
      value: '676754356'
    },
    {
      title: 'Instructivo',
      value: '84352'
    },
  ]
}

function card (cardData) {
  return (
    <React.Fragment>
      {cardData.sortedAttributes && cardData.sortedAttributes.length > 0 && (
        <CardContent>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
            mb={1}
          >
            <Typography variant="h4" component="div">
              {cardData.title}
              {bull}
              {cardData.subtitle}
              {bull}
            </Typography>
            {cardData.partial && <Chip label="Parcial" variant="outlined" />}
          </Stack>
          <Grid2 container spacing={2} mb={1}>
            <Grid2 size={0}></Grid2>
            <Grid2 size={5}>
              {cardData.sortedAttributes.map((item, index) => (
                <Div
                  sx={{ display: "flex", alignItems: "center", mb: 0 }}
                  key={index}
                >
                  {defaultIcons[item.title]
                    ? defaultIcons[item.title]
                    : defaultIcons["default"]}
                  <Typography variant="body2" color={"text.secondary"} ml={1}>
                    {item.title} :
                  </Typography>
                </Div>
              ))}
            </Grid2>
            <Grid2 size="grow">
              {cardData.sortedAttributes.map((item, index) => (
                <Tooltip key={index} title={item.value}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: 200,
                      display: 'block'
                    }}
                  >
                    {item.value}
                  </Typography>
                </Tooltip>
              ))}
            </Grid2>
          </Grid2>
        </CardContent>
      )}
    </React.Fragment>
  );
}

function OutlinedCard(props) {
  cardData.subtitle = props.delivery
  const summaryData = props.summaryData
  return (
    <Box sx={{ minWidth: 275 }}>
      <Card variant="outlined">{card(summaryData)}</Card>
    </Box>
  );
}

function ColorTabs(props) {
  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={props.value}
        onChange={props.handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="documents tabs"
      >
        <Tab value="signedAcknowledgement" label="Documentos" />
        { props.regularizationDisabled ?
          <Tooltip title={"Opción habilitada solo para entregas parciales"} placement="top-start">
            <span>
              <Tab value="regularizationStatus" label="Regularización" disabled />
            </span>
          </Tooltip>
          :
          <Tab value="regularizationStatus" label={"Regularización"} />
        }
      </Tabs>
    </Box>
  );
}

const DeliveryPopUp = props => {
  // I would like to save in a constant the original values I got,
  // and only allow the user to save if the values have changed
  const handleTabChange = props.handlePopUp;
  const [infoToSend, setInfoToSend] = useState({});
  const [disabledSaveBtn, setDisabledSaveBtn] = useState(true);
  const deliveryId = props.delivery;
  const [summaryData, setSummaryData] = useState({});
  const [regularizationData, setRegularizationData] = useState({});
  const [signedDocumentsData, setSignedDocumentsData] = useState({});
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const { enqueueSnackbar } = useSnackbar()

  const handleInfoToSend = (info) => {
    setInfoToSend({...infoToSend, ...info})
  }
  
  useEffect(() => {
  }, [infoToSend]);

  // console.log('deliveryId', deliveryId)

  // 1. documents summary of a delivery
  useEffect(() => {
    if (deliveryId) {
      deliveryServices.getDeliveryDocumentsSummary(deliveryId)
        .then((data) => {
          console.log("getDeliveryDocumentsSummary()", data)
          setSummaryData(data)
        }).catch((err) => {
          console.log("Error de getDeliveryDocumentsSummary()", err);
        });
    }
    return () => {
      setSummaryData({});
    }
  }, [deliveryId]);

  // 2. regularization info of a delivery
  useEffect(() => {
    if (deliveryId) {
      deliveryServices.getDeliveryRegularization(deliveryId)
        .then((data) => {
          console.log("getDeliveryRegularization()", data)
          setRegularizationData(data)
        }).catch((err) => {
          console.log("Error de getDeliveryRegularization()", err);
        });
    }
    return () => {
      setRegularizationData({});
    }
  }, [deliveryId]);

  // 3. signed documents info of a delivery
  useEffect(() => {
    if (deliveryId) {
      setSignedDocumentsData({});
      setLoadingDocuments(true);
      deliveryServices.getDeliveryDocumentsData(deliveryId)
        .then((data) => {
          setSignedDocumentsData(data || {});
        }).catch((err) => {
          console.log("Error de getDeliveryDocumentsData()", err);
        }).finally(() => {
          setLoadingDocuments(false);
        });
    }
    return () => {
      setSignedDocumentsData({});
    }
  }, [deliveryId]);


  const onSave = () => {
    console.log("Guardar:", infoToSend)
    if (infoToSend.regularization && infoToSend.regularization.documentType && infoToSend.regularization.documentNumber) {
      deliveryServices.updateRegularization(deliveryId, infoToSend.regularization).then((data) => {
        console.log("updateRegularization()", data)
        enqueueSnackbar("Regularización guardada correctamente", { variant: 'success' });
      }).catch((err) => {
        console.log("Error de updateRegularization()", err);
        enqueueSnackbar("Error al guardar la regularización", { variant: 'error' });
      });
    }
    if (infoToSend.contentReception) {
      deliveryServices.updateContentReception(deliveryId, infoToSend.contentReception).then((data) => {
        console.log("updateContentReception()", data)
      }).catch((err) => {
        console.log("Error de updateContentReception()", err);
      });
    }
    if (infoToSend.riskAcknowledgement) {
      deliveryServices.updateRiskAcknowledgement(deliveryId, infoToSend.riskAcknowledgement).then((data) => {
        console.log("updateRiskAcknowledgement()", data)
      }).catch((err) => {
        console.log("Error de updateRiskAcknowledgement()", err);
      });
    }
    props.onSave(infoToSend)
    // set the button to loading and with the result disable it
    setDisabledSaveBtn(true)
  }

  return (
    <React.Fragment>
      <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={props.isOpen}
          onClose={props.onClose}>
        <DialogContent>
          <ColorTabs value={props.tab} handleChange={handleTabChange} regularizationDisabled={!summaryData.partial} />
          <br></br>
          <Container maxWidth="lg">
            <OutlinedCard delivery={props.delivery} summaryData={summaryData} />
          </Container>
          <br></br>
          { props.tab === "signedAcknowledgement" && (
            loadingDocuments ? (
              <Box display="flex" justifyContent="center" alignItems="center" minHeight={100}>
                <CircularProgress />
              </Box>
              ) : (
              <DeliveryDocuments
                documentsData={signedDocumentsData}
                handleInfoToSend={handleInfoToSend}
                setDisabledSaveBtn={setDisabledSaveBtn}
                deliveryId={deliveryId}
                refreshDocumentsData={() => {
                  setLoadingDocuments(true);
                  deliveryServices.getDeliveryDocumentsData(deliveryId)
                      .then((data) => {
                          setSignedDocumentsData(data || {});
                      }).finally(() => {
                          setLoadingDocuments(false);
                      });
                }}
              />) 
            )
          }

          { props.tab === "regularizationStatus" &&
            <DeliveryRegularization
              handleInfoToSend={handleInfoToSend}
              setDisabledSaveBtn={setDisabledSaveBtn}
              regularizationData={regularizationData} />}
        </DialogContent>

        <DialogActions>
          <Button onClick={props.onClose} color="primary">
            Cancelar
          </Button>
          <Button variant="contained" onClick={onSave} color="primary" disabled={disabledSaveBtn}>
            Guardar
          </Button>
        </DialogActions>

      </Dialog>
    </React.Fragment>
  )
}

export default DeliveryPopUp;
